import { Route, Routes } from 'react-router-dom'
import useAuthentication from './hooks/useAuthentication'
import { ExpertsPage } from './pages/experts/Experts'
import { useEffect } from 'react'
import Spin from 'antd/lib/spin'
import { Loader } from './components/common/loader/Loader'
import { ErrorPage } from './pages/error/errorPage/ErrorPage'
import ErrorFlag from './assets/icons/error-flag.svg'
import SegmentAnalytics from './SegmentAnalytics'
import { useSelector } from 'react-redux'
import { userProfileSelector } from './store/auth/auth.selector'

const RoutesComp = () => {
    const {
        trigger: triggerAuthentication,
        customMessage,
        error,
        isAuthenticated,
        isLoading,
    } = useAuthentication()
    const profile = useSelector(userProfileSelector)

    useEffect(() => {
        triggerAuthentication()
    }, [triggerAuthentication])

    if (isLoading) {
        return <Spin indicator={<Loader title={'Loading...'} />} />
    }

    if (customMessage) {
        return <>{customMessage}</>
    }

    if (error) {
        return <div>{(error as { message: string }).message}</div>
    }

    if (!isAuthenticated) {
        return <Spin indicator={<Loader title={'Loading...'} />} />
    }

    if (isAuthenticated) {
        SegmentAnalytics.setInitialData(profile)
    }

    return (
        <Routes>
            <Route element={<ExpertsPage />} path="/" />
            <Route
                element={
                    <ErrorPage
                        text1={'Page not found'}
                        errorSVG={ErrorFlag}
                        btnTitle={'Redirect to Home Page'}
                        onClick={() => (window.location.href = '/')}
                    />
                }
                path="*"
            />
        </Routes>
    )
}

export default RoutesComp
